<section class="content">
  <div class="card" style="padding: 24px;">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-3">
        <mat-label>From Date</mat-label>
        <input type="date" [(ngModel)]="from_date" class="main-border-class" />
      </div>
      <div class="col-3">
        <mat-label>To Date</mat-label>
        <input type="date" [(ngModel)]="to_date" class="main-border-class" [min]="from_date" />
      </div>
      <div class="col-3">
        <mat-label>Select Booth type</mat-label>
        <mat-select [(ngModel)]="selected_business_type_ids" class="main-border-class" multiple>
          <mat-option [value]="business_type.id" *ngFor="let business_type of business_types">{{business_type['name']}}</mat-option>
        </mat-select>
      </div>
      <div class="col">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 5%;border-radius: 5px;background: blanchedalmond;"
          [disabled]="to_date == null || from_date == null">Get</button>
      </div>
    </div>
    <div *ngIf="!is_document_available">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
      </mat-progress-spinner>
    </div>
    <div class="row" *ngIf="document_file!== null">
      <div class="col-6"></div>
      <div class="col-6">
        <div class="row">
          <div class="col-4">
          </div>
          <div class="col-4">
            <button mat-button class="button-class" (click)="downloadClicked()"><i class="material-icons">
              get_app
              </i> Download Excel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>

</section>
